import { motion } from "framer-motion";
import { LogOut, KeyRound, Store, CloudDownload } from "lucide-react";

const STEPS = [
  {
    key: "sign-out",
    icon: LogOut,
    title: "Выйдите из Apple Account",
    desc: "В Настройках откройте свой аккаунт Apple и нажмите «Выйти». На следующем экране выберите «Выйти, но не стирать данные», затем нажмите «Продолжить».",
    caption: "Нажмите «Выйти», затем продолжите без стирания данных",
    screenshot: "/assets/prosto-guide/step-1-sign-out.png",
  },
  {
    key: "sign-in",
    icon: KeyRound,
    title: "Войдите в Apple Account",
    desc: "В Настройках откройте «Аккаунт Apple», выберите «Войти вручную» и введите выданные данные.",
    caption: "«Аккаунт Apple» → «Войти вручную»",
    screenshot: "/assets/prosto-guide/step-2-sign-in.png",
  },
  {
    key: "icloud-install",
    icon: Store,
    title: "Откройте iCloud и установите приложение",
    desc: "На экране аккаунта Apple откройте iCloud. Когда появится предложение установить приложение, нажмите «Установить».",
    caption: "Откройте iCloud и подтвердите установку",
    screenshot: "/assets/prosto-guide/step-3-icloud-install.png",
  },
  {
    key: "download",
    icon: CloudDownload,
    title: "Завершите установку",
    desc: "Подробная инструкция для этого шага будет добавлена позже.",
    caption: "Иллюстрация этого шага будет добавлена позже",
    screenshot: null,
  },
];

function ScreenshotFrame({ src, caption }) {
  return (
    <div className="mx-auto w-full max-w-[480px]">
      <div className="relative w-full overflow-hidden rounded-2xl border border-blue-300/20 bg-[#071329] shadow-[0_0_28px_rgba(47,107,255,0.22)]">
        {src ? (
          <img src={src} alt={caption} loading="lazy" className="block h-auto w-full rounded-xl object-contain" />
        ) : (
          <div className="flex min-h-48 flex-col items-center justify-center gap-2 px-5 text-center text-blue-100">
            <span className="grid h-10 w-10 place-items-center rounded-xl bg-blue-400/10 text-sm font-bold text-blue-200">Скриншот</span>
            <span className="text-xs leading-relaxed text-blue-100/65">Иллюстрация этого шага скоро появится</span>
          </div>
        )}
      </div>
      <p className="mt-2 text-center text-xs leading-relaxed text-blue-100/75">{caption}</p>
    </div>
  );
}

export default function ProstoInstallGuide() {
  return (
    <div className="space-y-3" data-testid="prosto-install-guide">
      {STEPS.map((step, i) => {
        const Icon = step.icon;
        return (
          <motion.article
            key={step.key}
            data-testid={`prosto-install-step-${i + 1}`}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-32px" }}
            transition={{ duration: 0.3, delay: i * 0.03 }}
            className="rounded-3xl border border-blue-300/20 bg-gradient-to-br from-[#0d1b35] to-[#081329] p-4 shadow-[0_12px_32px_rgba(4,12,30,0.32)] sm:p-5"
          >
            <div className="flex items-start gap-3">
              <span className="grid h-9 w-9 shrink-0 place-items-center rounded-2xl bg-[#2F6BFF] font-display text-base font-extrabold text-white shadow-md shadow-blue-500/25">{i + 1}</span>
              <div className="min-w-0 pt-0.5">
                <h3 className="flex items-center gap-2 font-display text-[15px] font-extrabold leading-snug text-white"><Icon size={16} className="shrink-0 text-blue-300" />{step.title}</h3>
                <p className="mt-1.5 text-[13px] leading-relaxed text-blue-100/75">{step.desc}</p>
              </div>
            </div>
            <div className="mt-4 rounded-2xl border border-blue-300/15 bg-[#09162d] p-3 shadow-[0_0_24px_rgba(47,107,255,0.12)]">
              <ScreenshotFrame src={step.screenshot} caption={step.caption} />
            </div>
          </motion.article>
        );
      })}
    </div>
  );
}
